__turbopack_context__.v({
  "avatar": "_8xOuwa_avatar",
  "img": "_8xOuwa_img",
  "imgpov_administrator": "_8xOuwa_imgpov_administrator",
  "imgpov_officer": "_8xOuwa_imgpov_officer",
  "item": "_8xOuwa_item",
  "itemactive": "_8xOuwa_itemactive",
  "name": "_8xOuwa_name",
  "nameactive": "_8xOuwa_nameactive",
  "role": "_8xOuwa_role",
  "roleactive": "_8xOuwa_roleactive",
  "svg": "_8xOuwa_svg",
  "svgpov_administrator": "_8xOuwa_svgpov_administrator",
  "svgpov_officer": "_8xOuwa_svgpov_officer",
  "text": "_8xOuwa_text",
});
